<template>
  <div>
    <Layout>
      <router-view class="view-box" />
      <CommonProgressBarComponent />
    </Layout>
  </div>
</template>

<script>
import Layout from "../../layouts/main";
import { useSimplepharmAuthModule } from "@/state/pinia/simplepharmAuthModule";
import { useCommonAppModule } from "@/state/pinia/commonAppModule";
import CommonProgressBarComponent from "@/components/widgets/CommonProgressBarComponent.vue";

export default {
  name: "DrugstoreCommonManager",
  components: {
    Layout,
    CommonProgressBarComponent,
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>